import React from 'react';
import { linkifyPurchaseText } from '../../utils/purchasingLinks';

const PurchaseLinkedText: React.FC<{ text: string; className?: string }> = ({ text, className }) => {
  const parts = linkifyPurchaseText(text);
  return (
    <>
      {parts.map((part, index) =>
        part.href ? (
          <a
            key={`${index}-${part.href}`}
            className={className}
            href={part.href}
            target="_blank"
            rel="noreferrer"
          >
            {part.text}
          </a>
        ) : (
          <React.Fragment key={`${index}-text`}>{part.text}</React.Fragment>
        ),
      )}
    </>
  );
};

export default PurchaseLinkedText;
